import { __ } from '@wordpress/i18n';
import { useState, useEffect } from 'react';
import { withSelect, dispatch } from '@wordpress/data';
import { store } from 'jkit-core/store';
import TemplatesContent from './templates-content';
import { getTemplateLists } from './helper';
import { Loader } from 'react-feather';

const TemplateBuilder = (props) => {
    const { templateData } = props;
    const [loading, setLoading] = useState(true);
    const { themeBuilderDesc } = window['JkitDashboardOption'];

    const { menuTitle, activeMenu } = props;
    useEffect(() => {
        if (!templateData) {
            getTemplateLists(activeMenu).then(result => {
                dispatch(store).initialTemplate({
                    "template": {
                        [activeMenu]: result
                    },
                });
                setLoading(false);
            });
        } else if (!templateData[activeMenu]) {
            getTemplateLists(activeMenu).then(result => {
                dispatch(store).setTemplate({
                    key: activeMenu,
                    value: result
                });
                setLoading(false);
            });
        } else {
            setLoading(false)
        }
    }, [activeMenu]);

    if (loading || undefined === templateData || undefined === templateData[activeMenu]) {

        return <div className="loading">
            <Loader size={28} />
        </div>
    } else {
        return < TemplatesContent key={activeMenu} templates={templateData[activeMenu]} desc={themeBuilderDesc[activeMenu]} menuTitle={menuTitle} activeMenu={activeMenu} />
    }

}

export default withSelect(select => {
    const { getTemplateData } = select('jkit/dashboard');

    return {
        templateData: getTemplateData()
    };
})(TemplateBuilder);